<template>
  <div v-if="query.status != 'staff'">

    <div class="btn-group-vertical btn-group-sm radiosAsButtons">
      <label class="btn" :class="getClass('new')">
        <input v-model="pendingStatus" type="radio" name="pendingStatus" value="new"> Uusi
      </label>

      <label class="btn" :class="getClass('checking_availability')">
        <input v-model="pendingStatus" type="radio" name="pendingStatus" value="checking_availability"> Selvitetään saatavuutta
      </label>

      <label class="btn" :class="getClass('waiting')">
        <input v-model="pendingStatus" type="radio" name="pendingStatus" value="waiting"> Odotetaan kuvailukappaletta
      </label>  

      <label class="btn" :class="getClass('in_virtual_list')">
        <input v-model="pendingStatus" type="radio" name="pendingStatus" value="in_virtual_list"> Virtulistalla
      </label>  

      <label class="btn" :class="getClass('processing')">
        <input v-model="pendingStatus" type="radio" name="pendingStatus" value="processing"> Käsittelyssä
      </label>

      <label class="btn" :class="getClass('ready')">
        <input v-model="pendingStatus" type="radio" name="pendingStatus" value="ready"> Valmis
      </label>
    </div>

    <span v-show="loading" class="query-status-spinner">
      <i class="fa fa-spinner fa-spin fa-lg fa-fw"></i>
      <span class="sr-only">Loading...</span>
    </span>

  </div>
</template>

<script>

import { userMixin } from '@/mixins/userMixin.js'

export default {
  components: {
  },

  mixins: [
    userMixin,
  ],

  props: {
    query: Object,
  },

  data() {
    return {
      pendingStatus: this.query.status, /* user selected status with radio inputs */
      queryStatus: this.query.status,   /* saved status in DB */
      loading: false,
      error: false,
    }
  },

  computed: {
  },

  watch: {
    pendingStatus(value) {
      this.sendStatus(value)
    },
  },

  created() {
  },

  methods: {

    getClass(name) {
      if (name != this.queryStatus) { 
        return 'btn-default' 
      }
      
      let classes = []

      classes.push('active')

      switch (this.queryStatus) {
        case 'new':
          classes.push('btn-danger')
          break;
        case 'checking_availability':
          classes.push('btn-warning')
          break;
        case 'waiting':
          classes.push('btn-success')
          break;
        case 'in_virtual_list':
          classes.push('btn-info')
          break;
        case 'processing':
          classes.push('btn-info')
          break;      
        default:
          classes.push('btn-default')  // == 'ready'
          break;
      }

      return classes.join(' ')
    },

    sendStatus(status) {
      this.loading = true
      this.error = false

      axios.put(`/staff/kysely/${this.query.id}`,
        {
          'status': status,
        }
      )
      .then((response) => {
        console.log(response)
        this.queryStatus = status
      })
      .catch((error) => {
        this.error = true
        console.log(error)
      })
      .finally(() => {
        this.loading = false
      });
    },

  },

}

</script>

<style scoped>

  /* input rules copied from bootstrap */
  .radiosAsButtons > .btn input[type=radio] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none;
  }
  
</style>
